import { IShopifyLiquidCustomer } from "@smartrr/shared/shopifyLiquid/customer";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";

export const getMockValidationAndCustomerLiquid = async (
  shopifyId: string,
  liquidCustomer: IShopifyLiquidCustomer,
  sig: string,
  exp: string
) =>
  await typedCustomerFrontendApi.putReq("/customer-relationship/:shopifyId/view-as-customer-validation", {
    params: { shopifyId },
    reqBody: {
      liquidCustomer,
      sig,
      exp,
    },
  });
